/**
 * Quoted Post Card
 * Compact embed of an original post inside a quote repost.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { formatPostTimestampToRelative } from '../../utils/formatPostTimestampToRelative';
import VerifiedBadge from '../common/VerifiedBadge';

const QuotedPostCard = ({ post }) => {
  if (!post) {
    return <div className="quoted-post quoted-post-missing">The original post is unavailable.</div>;
  }
  const text = post.content || '';
  const snippet = text.length > 240 ? `${text.slice(0, 240)}…` : text;

  return (
    <Link to={`/post/${post._id}`} className="quoted-post">
      <div className="quoted-post-header">
        {post.author?.avatar ? (
          <img src={post.author.avatar} alt={post.author.username} className="quoted-post-avatar" />
        ) : (
          <div className="quoted-post-avatar quoted-post-avatar-placeholder">
            {post.author?.username?.charAt(0).toUpperCase()}
          </div>
        )}
        <span className="quoted-post-author">
          {post.author?.fullName || post.author?.username}
          {post.author?.isVerified && <VerifiedBadge size={12} />}
        </span>
        <span className="quoted-post-date">· {formatPostTimestampToRelative(post.createdAt)}</span>
      </div>
      <div className="quoted-post-content">{snippet}</div>
    </Link>
  );
};

export default QuotedPostCard;
